import { type AxiosError, isAxiosError } from 'axios'

import { queryErrorHandler } from './react-query/queryErrorHandler'

export const LEARNPATH_ELEMENTS_CHANGED_TOAST_EVENT =
  'learnpath-elements-changed-toast'

export const LEARNPATH_ELEMENT_NOT_FOUND_ERROR_CODES = [
  'learnpath.error.learnpath-element-not-found',
  'learnpath.error.learnpath-embedded-video-element-not-found',
  'learnpath.error.learnpath-event-element-not-found',
  'learnpath.error.learnpath-file-element-not-found',
  'learnpath.error.learnpath-link-element-not-found',
  'learnpath.error.learnpath-platform-topic-element-not-found',
  'learnpath.error.learnpath-quiz-element-not-found',
  'learnpath.error.learnpath-quiz-element-question-not-found',
  'learnpath.error.learnpath-scorm-element-not-found',
  'learnpath.error.learnpath-video-element-not-found',
  'lecture.error.lecture-not-found',
] as const

const LECTURE_NOT_FOUND_CODE = 'lecture.error.lecture-not-found'
const CODES = LEARNPATH_ELEMENT_NOT_FOUND_ERROR_CODES as readonly string[]

function getRequestUrl(error: AxiosError): string {
  const url =
    error.config?.url ??
    (error.request as XMLHttpRequest | undefined)?.responseURL
  return url ?? ''
}

function isAssignedElement404(error: AxiosError): boolean {
  if (error.response?.status !== 404) return false
  const url = getRequestUrl(error)
  return (
    url.includes('learnpaths/assigned') &&
    url.includes('/elements/') &&
    !url.includes('check_question')
  )
}

export function isLearnpathElementNotFoundError(error: unknown): boolean {
  if (!isAxiosError(error) || error.response?.status !== 404) return false

  const message = queryErrorHandler(error)
  if (typeof message !== 'string') return false

  if (CODES.includes(message) && message !== LECTURE_NOT_FOUND_CODE) return true
  if (isAssignedElement404(error)) return true
  if (message === LECTURE_NOT_FOUND_CODE)
    return getRequestUrl(error).includes('learnpath_id')

  return false
}
